import React from 'react'
import cn from 'classnames'

import ProductsListWhite from 'assets/svg/products-list-white.svg'
import ProductsList from 'assets/svg/products-list.svg'
import ArrowDownGreen from 'assets/svg/arrow_down_green.svg'

import './ProductsBadge.scss'

const ProductsBadge = ({ onClick, show, mobile, children }) => (
    <>
        <div
            id="productFullContainer"
            className={cn({ 'products-open': show, 'products-close': !show })}
            onClick={onClick}
        />
        <div className={cn('products-badge-content', { white: show })}>
            <div className="products" onClick={onClick}>
                <div id="productBadge" className="products__badge">
                    <img
                        className="products__logo"
                        width={30}
                        height={30}
                        src={mobile && show ? ProductsListWhite : ProductsList}
                        alt="Logotipo Alelo"
                    />
                    <span className="products__description">
                        <span>nossos</span>
                        <br /> <span>produtos</span>
                        <img
                            style={{
                                marginLeft: '8px',
                                width: '8px',
                                height: '6px'
                            }}
                            src={ArrowDownGreen}
                            alt="Arrow Alelo"
                        />
                    </span>
                </div>
            </div>
            {children}
        </div>
    </>
)

export default ProductsBadge
